import { memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent, implementCustomInvariants } from '../__generated/implementation.js';
import { stackItemComponent } from '../other/stack-component.js';
import { getBottomWallStackId, getCountertopWallStackId, getTopWallStackId, getWallIdFromStackKey } from './wall.js';
export const wallItemInvariants = implementCustomInvariants({
    CountertopWallItem: {
        isOnWorkSurface: (s)=>{
            const xStart = s.x;
            const xEnd = s.x + s.$width;
            const isOnWorkSurface = s.$wall.$continuousCountertopSpaces.some((workSurface)=>xStart >= workSurface.minX && xEnd <= workSurface.maxX);
            if (!isOnWorkSurface) {
                return [
                    {
                        type: 'isOnWorkSurface',
                        severity: 'fatal',
                        message: `The ${s.$name} requires a free countertop section, but no unobstructed countertop space is available.`
                    }
                ];
            }
            return [];
        }
    }
});
export const customWallItemComponents = [
    attachComponent.withComponent(stackItemComponent, 'stackItem').withAlias('BottomWallItem').attach(memoEval((s)=>[
            s.x,
            s.$width,
            s.wallId
        ], (x, width, wallId)=>({
            x,
            width,
            stackKey: getBottomWallStackId(wallId)
        })), (v)=>{
        return {
            x: v.x,
            wallId: getWallIdFromStackKey(v.stackKey)
        };
    }),
    attachComponent.withComponent(stackItemComponent, 'stackItem').withAlias('TopWallItem').attach(memoEval((s)=>[
            s.x,
            s.$width,
            s.wallId
        ], (x, width, wallId)=>({
            x,
            width,
            stackKey: getTopWallStackId(wallId)
        })), (v)=>{
        return {
            x: v.x,
            wallId: getWallIdFromStackKey(v.stackKey)
        };
    }),
    attachComponent.withComponent(stackItemComponent, 'stackItem').withAlias('CountertopWallItem').attach(memoEval((s)=>[
            s.x,
            s.$width,
            s.wallId
        ], (x, width, wallId)=>({
            x,
            width,
            stackKey: getCountertopWallStackId(wallId)
        })), (v)=>{
        return {
            x: v.x,
            wallId: getWallIdFromStackKey(v.stackKey)
        };
    })
];

//# sourceMappingURL=wall-item.js.map